import type React from 'react';

export interface AfIconProps {
	width?: string | number;
	height?: string | number;
	color?: string;
	'aria-label'?: string;
}

const AfIcon: React.FC<AfIconProps> = ({
	width = 25,
	height = 25,
	color = 'currentColor',
	'aria-label': ariaLabel = 'Accounting & Finance Icon',
}) => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 25 25"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-label={ariaLabel}
		style={{ color }}
	>
		<path
			d="M14.0286 13.6428H12.7589C12.5482 13.6428 12.3779 13.4721 12.3779 13.2618C12.3779 13.0515 12.5482 12.8809 12.7589 12.8809H14.0286C14.2393 12.8809 14.4095 13.0515 14.4095 13.2618C14.4095 13.4721 14.2393 13.6428 14.0286 13.6428Z"
			fill="currentColor"
		/>
		<path
			d="M14.0286 15.9287H12.7589C12.5482 15.9287 12.3779 15.758 12.3779 15.5477C12.3779 15.3374 12.5482 15.1667 12.7589 15.1667H14.0286C14.2393 15.1667 14.4095 15.3374 14.4095 15.5477C14.4095 15.758 14.2393 15.9287 14.0286 15.9287Z"
			fill="currentColor"
		/>
		<path
			d="M14.0286 18.2143H12.7589C12.5482 18.2143 12.3779 18.0436 12.3779 17.8333C12.3779 17.6231 12.5482 17.4524 12.7589 17.4524H14.0286C14.2393 17.4524 14.4095 17.6231 14.4095 17.8333C14.4095 18.0436 14.2393 18.2143 14.0286 18.2143Z"
			fill="currentColor"
		/>
		<path
			d="M16.3145 14.4046C16.1039 14.4046 15.9336 14.234 15.9336 14.0237V6.40463C15.9336 6.19435 16.1039 6.02368 16.3145 6.02368C16.5252 6.02368 16.6955 6.19435 16.6955 6.40463V14.0237C16.6955 14.234 16.5252 14.4046 16.3145 14.4046Z"
			fill="currentColor"
		/>
		<path
			d="M14.7911 20.4999C14.5804 20.4999 14.4102 20.3292 14.4102 20.1189C14.4102 19.9087 14.5804 19.738 14.7911 19.738C14.9157 19.738 15.0387 19.7178 15.1576 19.6778C15.3568 19.6111 15.5732 19.7178 15.6403 19.917C15.7077 20.1163 15.6006 20.3327 15.401 20.3997C15.2037 20.4664 14.9983 20.4999 14.7911 20.4999Z"
			fill="currentColor"
		/>
		<path
			d="M14.7902 20.4999H6.40927C6.19861 20.4999 6.02832 20.3293 6.02832 20.119C6.02832 19.9087 6.19861 19.738 6.40927 19.738H14.7902C15.0009 19.738 15.1712 19.9087 15.1712 20.119C15.1712 20.3293 15.0009 20.4999 14.7902 20.4999Z"
			fill="currentColor"
		/>
		<path
			d="M20.1241 16.4365C19.9134 16.4365 19.7432 16.2658 19.7432 16.0555C19.7432 15.9854 19.6864 15.9287 19.6163 15.9287C19.4056 15.9287 19.2354 15.758 19.2354 15.5477C19.2354 15.3374 19.4056 15.1667 19.6163 15.1667C20.1062 15.1667 20.5051 15.5656 20.5051 16.0555C20.5051 16.2662 20.3348 16.4365 20.1241 16.4365Z"
			fill="currentColor"
		/>
		<path
			d="M20.1241 16.9445C19.9134 16.9445 19.7432 16.7739 19.7432 16.5636V16.0558C19.7432 15.8455 19.9134 15.6748 20.1241 15.6748C20.3348 15.6748 20.5051 15.8455 20.5051 16.0558V16.5636C20.5051 16.7739 20.3348 16.9445 20.1241 16.9445Z"
			fill="currentColor"
		/>
		<path
			d="M19.6163 17.4523C19.4056 17.4523 19.2354 17.2817 19.2354 17.0714C19.2354 16.8611 19.4056 16.6904 19.6163 16.6904C19.6864 16.6904 19.7432 16.6337 19.7432 16.5636C19.7432 16.3533 19.9134 16.1826 20.1241 16.1826C20.3348 16.1826 20.5051 16.3533 20.5051 16.5636C20.5051 17.0535 20.1062 17.4523 19.6163 17.4523Z"
			fill="currentColor"
		/>
		<path
			d="M15.5528 17.4523C15.0629 17.4523 14.6641 17.0535 14.6641 16.5636C14.6641 16.3533 14.8343 16.1826 15.045 16.1826C15.2557 16.1826 15.426 16.3533 15.426 16.5636C15.426 16.6337 15.4827 16.6904 15.5528 16.6904C15.7635 16.6904 15.9338 16.8611 15.9338 17.0714C15.9338 17.2817 15.7635 17.4523 15.5528 17.4523Z"
			fill="currentColor"
		/>
		<path
			d="M15.045 16.9445C14.8343 16.9445 14.6641 16.7739 14.6641 16.5636V16.0558C14.6641 15.8455 14.8343 15.6748 15.045 15.6748C15.2557 15.6748 15.426 15.8455 15.426 16.0558V16.5636C15.426 16.7739 15.2557 16.9445 15.045 16.9445Z"
			fill="currentColor"
		/>
		<path
			d="M15.045 16.4365C14.8343 16.4365 14.6641 16.2658 14.6641 16.0555C14.6641 15.5656 15.0629 15.1667 15.5528 15.1667C15.7635 15.1667 15.9338 15.3374 15.9338 15.5477C15.9338 15.758 15.7635 15.9287 15.5528 15.9287C15.4827 15.9287 15.426 15.9854 15.426 16.0555C15.426 16.2662 15.2557 16.4365 15.045 16.4365Z"
			fill="currentColor"
		/>
		<path
			d="M19.6163 15.9286C19.4056 15.9286 19.2354 15.758 19.2354 15.5477C19.2354 15.3374 19.4056 15.1667 19.6163 15.1667C19.6864 15.1667 19.7432 15.11 19.7432 15.0399C19.7432 14.8296 19.9134 14.6589 20.1241 14.6589C20.3348 14.6589 20.5051 14.8296 20.5051 15.0399C20.5051 15.5298 20.1062 15.9286 19.6163 15.9286Z"
			fill="currentColor"
		/>
		<path
			d="M19.6164 15.9287H15.5528C15.3422 15.9287 15.1719 15.758 15.1719 15.5477C15.1719 15.3374 15.3422 15.1667 15.5528 15.1667H19.6164C19.8271 15.1667 19.9974 15.3374 19.9974 15.5477C19.9974 15.758 19.8271 15.9287 19.6164 15.9287Z"
			fill="currentColor"
		/>
		<path
			d="M20.1241 15.4208C19.9134 15.4208 19.7432 15.2502 19.7432 15.0399V14.5321C19.7432 14.3218 19.9134 14.1511 20.1241 14.1511C20.3348 14.1511 20.5051 14.3218 20.5051 14.5321V15.0399C20.5051 15.2502 20.3348 15.4208 20.1241 15.4208Z"
			fill="currentColor"
		/>
		<path
			d="M20.1241 14.9125C19.9134 14.9125 19.7432 14.7419 19.7432 14.5316C19.7432 14.4615 19.6864 14.4047 19.6163 14.4047C19.4056 14.4047 19.2354 14.2341 19.2354 14.0238C19.2354 13.8135 19.4056 13.6428 19.6163 13.6428C20.1062 13.6428 20.5051 14.0417 20.5051 14.5316C20.5051 14.7423 20.3348 14.9125 20.1241 14.9125Z"
			fill="currentColor"
		/>
		<path
			d="M19.6164 14.4047H15.5528C15.3422 14.4047 15.1719 14.2341 15.1719 14.0238C15.1719 13.8135 15.3422 13.6428 15.5528 13.6428H19.6164C19.8271 13.6428 19.9974 13.8135 19.9974 14.0238C19.9974 14.2341 19.8271 14.4047 19.6164 14.4047Z"
			fill="currentColor"
		/>
		<path
			d="M15.045 14.9125C14.8343 14.9125 14.6641 14.7419 14.6641 14.5316C14.6641 14.0417 15.0629 13.6428 15.5528 13.6428C15.7635 13.6428 15.9338 13.8135 15.9338 14.0238C15.9338 14.2341 15.7635 14.4047 15.5528 14.4047C15.4827 14.4047 15.426 14.4615 15.426 14.5316C15.426 14.7423 15.2557 14.9125 15.045 14.9125Z"
			fill="currentColor"
		/>
		<path
			d="M15.045 15.4208C14.8343 15.4208 14.6641 15.2502 14.6641 15.0399V14.5321C14.6641 14.3218 14.8343 14.1511 15.045 14.1511C15.2557 14.1511 15.426 14.3218 15.426 14.5321V15.0399C15.426 15.2502 15.2557 15.4208 15.045 15.4208Z"
			fill="currentColor"
		/>
		<path
			d="M15.5528 15.9286C15.0629 15.9286 14.6641 15.5298 14.6641 15.0399C14.6641 14.8296 14.8343 14.6589 15.045 14.6589C15.2557 14.6589 15.426 14.8296 15.426 15.0399C15.426 15.11 15.4827 15.1667 15.5528 15.1667C15.7635 15.1667 15.9338 15.3374 15.9338 15.5477C15.9338 15.758 15.7635 15.9286 15.5528 15.9286Z"
			fill="currentColor"
		/>
		<path
			d="M19.6163 18.9763C19.4056 18.9763 19.2354 18.8056 19.2354 18.5953C19.2354 18.385 19.4056 18.2144 19.6163 18.2144C19.6864 18.2144 19.7432 18.1576 19.7432 18.0875C19.7432 17.8772 19.9134 17.7065 20.1241 17.7065C20.3348 17.7065 20.5051 17.8772 20.5051 18.0875C20.5051 18.5774 20.1062 18.9763 19.6163 18.9763Z"
			fill="currentColor"
		/>
		<path
			d="M20.1241 18.4684C19.9134 18.4684 19.7432 18.2978 19.7432 18.0875V17.5797C19.7432 17.3694 19.9134 17.1987 20.1241 17.1987C20.3348 17.1987 20.5051 17.3694 20.5051 17.5797V18.0875C20.5051 18.2978 20.3348 18.4684 20.1241 18.4684Z"
			fill="currentColor"
		/>
		<path
			d="M20.1241 17.9601C19.9134 17.9601 19.7432 17.7895 19.7432 17.5792C19.7432 17.5091 19.6864 17.4523 19.6163 17.4523C19.4056 17.4523 19.2354 17.2817 19.2354 17.0714C19.2354 16.8611 19.4056 16.6904 19.6163 16.6904C20.1062 16.6904 20.5051 17.0893 20.5051 17.5792C20.5051 17.7899 20.3348 17.9601 20.1241 17.9601Z"
			fill="currentColor"
		/>
		<path
			d="M19.6164 17.4523H15.5528C15.3422 17.4523 15.1719 17.2817 15.1719 17.0714C15.1719 16.8611 15.3422 16.6904 15.5528 16.6904H19.6164C19.8271 16.6904 19.9974 16.8611 19.9974 17.0714C19.9974 17.2817 19.8271 17.4523 19.6164 17.4523Z"
			fill="currentColor"
		/>
		<path
			d="M15.045 17.9601C14.8343 17.9601 14.6641 17.7895 14.6641 17.5792C14.6641 17.0893 15.0629 16.6904 15.5528 16.6904C15.7635 16.6904 15.9338 16.8611 15.9338 17.0714C15.9338 17.2817 15.7635 17.4523 15.5528 17.4523C15.4827 17.4523 15.426 17.5091 15.426 17.5792C15.426 17.7899 15.2557 17.9601 15.045 17.9601Z"
			fill="currentColor"
		/>
		<path
			d="M15.045 18.4684C14.8343 18.4684 14.6641 18.2978 14.6641 18.0875V17.5797C14.6641 17.3694 14.8343 17.1987 15.045 17.1987C15.2557 17.1987 15.426 17.3694 15.426 17.5797V18.0875C15.426 18.2978 15.2557 18.4684 15.045 18.4684Z"
			fill="currentColor"
		/>
		<path
			d="M15.5528 18.9763C15.0629 18.9763 14.6641 18.5774 14.6641 18.0875C14.6641 17.8772 14.8343 17.7065 15.045 17.7065C15.2557 17.7065 15.426 17.8772 15.426 18.0875C15.426 18.1576 15.4827 18.2144 15.5528 18.2144C15.7635 18.2144 15.9338 18.385 15.9338 18.5953C15.9338 18.8056 15.7635 18.9763 15.5528 18.9763Z"
			fill="currentColor"
		/>
		<path
			d="M20.1241 19.4841C19.9134 19.4841 19.7432 19.3134 19.7432 19.1031C19.7432 19.033 19.6864 18.9763 19.6163 18.9763C19.4056 18.9763 19.2354 18.8056 19.2354 18.5953C19.2354 18.385 19.4056 18.2144 19.6163 18.2144C20.1062 18.2144 20.5051 18.6132 20.5051 19.1031C20.5051 19.3138 20.3348 19.4841 20.1241 19.4841Z"
			fill="currentColor"
		/>
		<path
			d="M19.6164 18.9763H15.5528C15.3422 18.9763 15.1719 18.8056 15.1719 18.5953C15.1719 18.385 15.3422 18.2144 15.5528 18.2144H19.6164C19.8271 18.2144 19.9974 18.385 19.9974 18.5953C19.9974 18.8056 19.8271 18.9763 19.6164 18.9763Z"
			fill="currentColor"
		/>
		<path
			d="M20.1241 19.9921C19.9134 19.9921 19.7432 19.8215 19.7432 19.6112V19.1034C19.7432 18.8931 19.9134 18.7224 20.1241 18.7224C20.3348 18.7224 20.5051 18.8931 20.5051 19.1034V19.6112C20.5051 19.8215 20.3348 19.9921 20.1241 19.9921Z"
			fill="currentColor"
		/>
		<path
			d="M19.6163 20.4999C19.4056 20.4999 19.2354 20.3293 19.2354 20.119C19.2354 19.9087 19.4056 19.738 19.6163 19.738C19.6864 19.738 19.7432 19.6813 19.7432 19.6112C19.7432 19.4009 19.9134 19.2302 20.1241 19.2302C20.3348 19.2302 20.5051 19.4009 20.5051 19.6112C20.5051 20.1011 20.1062 20.4999 19.6163 20.4999Z"
			fill="currentColor"
		/>
		<path
			d="M19.6164 20.4999H15.5528C15.3422 20.4999 15.1719 20.3293 15.1719 20.119C15.1719 19.9087 15.3422 19.738 15.5528 19.738H19.6164C19.8271 19.738 19.9974 19.9087 19.9974 20.119C19.9974 20.3293 19.8271 20.4999 19.6164 20.4999Z"
			fill="currentColor"
		/>
		<path
			d="M15.5528 20.4999C15.0629 20.4999 14.6641 20.1011 14.6641 19.6112C14.6641 19.4009 14.8343 19.2302 15.045 19.2302C15.2557 19.2302 15.426 19.4009 15.426 19.6112C15.426 19.6813 15.4827 19.738 15.5528 19.738C15.7635 19.738 15.9338 19.9087 15.9338 20.119C15.9338 20.3293 15.7635 20.4999 15.5528 20.4999Z"
			fill="currentColor"
		/>
		<path
			d="M15.045 19.9921C14.8343 19.9921 14.6641 19.8215 14.6641 19.6112V19.1034C14.6641 18.8931 14.8343 18.7224 15.045 18.7224C15.2557 18.7224 15.426 18.8931 15.426 19.1034V19.6112C15.426 19.8215 15.2557 19.9921 15.045 19.9921Z"
			fill="currentColor"
		/>
		<path
			d="M15.045 19.4841C14.8343 19.4841 14.6641 19.3134 14.6641 19.1031C14.6641 18.6132 15.0629 18.2144 15.5528 18.2144C15.7635 18.2144 15.9338 18.385 15.9338 18.5953C15.9338 18.8056 15.7635 18.9763 15.5528 18.9763C15.4827 18.9763 15.426 19.033 15.426 19.1031C15.426 19.3138 15.2557 19.4841 15.045 19.4841Z"
			fill="currentColor"
		/>
		<path
			d="M14.0284 11.3571C13.8177 11.3571 13.6475 11.1864 13.6475 10.9761V7.1666C13.6475 6.95631 13.8177 6.78564 14.0284 6.78564C14.2391 6.78564 14.4094 6.95631 14.4094 7.1666V10.9761C14.4094 11.1864 14.2391 11.3571 14.0284 11.3571Z"
			fill="currentColor"
		/>
		<path
			d="M14.0291 7.54755H7.17197C6.9613 7.54755 6.79102 7.37688 6.79102 7.1666C6.79102 6.95631 6.9613 6.78564 7.17197 6.78564H14.0291C14.2398 6.78564 14.4101 6.95631 14.4101 7.1666C14.4101 7.37688 14.2398 7.54755 14.0291 7.54755Z"
			fill="currentColor"
		/>
		<path
			d="M7.17197 11.3571C6.9613 11.3571 6.79102 11.1864 6.79102 10.9761V7.1666C6.79102 6.95631 6.9613 6.78564 7.17197 6.78564C7.38263 6.78564 7.55292 6.95631 7.55292 7.1666V10.9761C7.55292 11.1864 7.38263 11.3571 7.17197 11.3571Z"
			fill="currentColor"
		/>
		<path
			d="M11.235 13.6428H9.96494C9.75427 13.6428 9.58398 13.4721 9.58398 13.2618C9.58398 13.0515 9.75427 12.8809 9.96494 12.8809H11.235C11.4457 12.8809 11.616 13.0515 11.616 13.2618C11.616 13.4721 11.4457 13.6428 11.235 13.6428Z"
			fill="currentColor"
		/>
		<path
			d="M8.44168 13.6428H7.17197C6.9613 13.6428 6.79102 13.4721 6.79102 13.2618C6.79102 13.0515 6.9613 12.8809 7.17197 12.8809H8.44168C8.65235 12.8809 8.82263 13.0515 8.82263 13.2618C8.82263 13.4721 8.65235 13.6428 8.44168 13.6428Z"
			fill="currentColor"
		/>
		<path
			d="M11.235 15.9287H9.96494C9.75427 15.9287 9.58398 15.758 9.58398 15.5477C9.58398 15.3374 9.75427 15.1667 9.96494 15.1667H11.235C11.4457 15.1667 11.616 15.3374 11.616 15.5477C11.616 15.758 11.4457 15.9287 11.235 15.9287Z"
			fill="currentColor"
		/>
		<path
			d="M8.44168 15.9287H7.17197C6.9613 15.9287 6.79102 15.758 6.79102 15.5477C6.79102 15.3374 6.9613 15.1667 7.17197 15.1667H8.44168C8.65235 15.1667 8.82263 15.3374 8.82263 15.5477C8.82263 15.758 8.65235 15.9287 8.44168 15.9287Z"
			fill="currentColor"
		/>
		<path
			d="M11.235 18.2143H9.96494C9.75427 18.2143 9.58398 18.0436 9.58398 17.8333C9.58398 17.6231 9.75427 17.4524 9.96494 17.4524H11.235C11.4457 17.4524 11.616 17.6231 11.616 17.8333C11.616 18.0436 11.4457 18.2143 11.235 18.2143Z"
			fill="currentColor"
		/>
		<path
			d="M8.44168 18.2143H7.17197C6.9613 18.2143 6.79102 18.0436 6.79102 17.8333C6.79102 17.6231 6.9613 17.4524 7.17197 17.4524H8.44168C8.65235 17.4524 8.82263 17.6231 8.82263 17.8333C8.82263 18.0436 8.65235 18.2143 8.44168 18.2143Z"
			fill="currentColor"
		/>
		<path
			d="M14.0291 11.3571H7.17197C6.9613 11.3571 6.79102 11.1865 6.79102 10.9762C6.79102 10.7659 6.9613 10.5952 7.17197 10.5952H14.0291C14.2398 10.5952 14.4101 10.7659 14.4101 10.9762C14.4101 11.1865 14.2398 11.3571 14.0291 11.3571Z"
			fill="currentColor"
		/>
		<path
			d="M6.40964 20.5001C5.35936 20.5001 4.50488 19.6456 4.50488 18.5953C4.50488 18.385 4.67517 18.2144 4.88584 18.2144C5.0965 18.2144 5.26679 18.385 5.26679 18.5953C5.26679 19.2254 5.77955 19.7382 6.40964 19.7382C6.62031 19.7382 6.7906 19.9088 6.7906 20.1191C6.7906 20.3294 6.62031 20.5001 6.40964 20.5001Z"
			fill="currentColor"
		/>
		<path
			d="M4.88584 18.9761C4.67517 18.9761 4.50488 18.8054 4.50488 18.5951V6.40463C4.50488 6.19435 4.67517 6.02368 4.88584 6.02368C5.0965 6.02368 5.26679 6.19435 5.26679 6.40463V18.5951C5.26679 18.8054 5.0965 18.9761 4.88584 18.9761Z"
			fill="currentColor"
		/>
		<path
			d="M16.3149 6.78571C16.1043 6.78571 15.934 6.61505 15.934 6.40476C15.934 5.77467 15.4212 5.2619 14.7911 5.2619C14.5804 5.2619 14.4102 5.09124 14.4102 4.88095C14.4102 4.67067 14.5804 4.5 14.7911 4.5C15.8414 4.5 16.6959 5.35448 16.6959 6.40476C16.6959 6.61505 16.5256 6.78571 16.3149 6.78571Z"
			fill="currentColor"
		/>
		<path
			d="M14.7902 5.2619H6.40927C6.19861 5.2619 6.02832 5.09124 6.02832 4.88095C6.02832 4.67067 6.19861 4.5 6.40927 4.5H14.7902C15.0009 4.5 15.1712 4.67067 15.1712 4.88095C15.1712 5.09124 15.0009 5.2619 14.7902 5.2619Z"
			fill="currentColor"
		/>
		<path
			d="M4.88584 6.78571C4.67517 6.78571 4.50488 6.61505 4.50488 6.40476C4.50488 5.35448 5.35936 4.5 6.40964 4.5C6.62031 4.5 6.7906 4.67067 6.7906 4.88095C6.7906 5.09124 6.62031 5.2619 6.40964 5.2619C5.77955 5.2619 5.26679 5.77467 5.26679 6.40476C5.26679 6.61505 5.0965 6.78571 4.88584 6.78571Z"
			fill="currentColor"
		/>
	</svg>
);

export default AfIcon;
